import React, { Component } from 'react';
import ajaxWrapper from 'base/ajax.js';
import CSVtoArray from 'base/csvToArray.js';
import settings from 'base/settings.js';
import {Header} from 'library';



class StatList extends React.Component {

    render() {

        var titles = CSVtoArray(this.props.titles)
        var descriptions =  CSVtoArray(this.props.descriptions)

        var columns = []
        for (var index in titles) {
          columns.push(<div className="col">
            <h3 style={{'fontSize':'70px', letterSpacing:'-5px', fontWeight:'bold'}}>{titles[index] || ''}</h3>
            <p style={{fontSize:'12px', fontWeight:'bold', letterSpacing:'2px', color:'#a5a5a5'}}>{descriptions[index]}</p>
          </div>)
        }

        return (
          <section className="container" style={{paddingTop:'50px'}}>
            <div className="row" style={{'textAlign':'center'}}>
              {columns}
            </div>
          </section>
        );
    }
}


export default StatList;
